import React from 'react';

const SECTIONS = [
  {
    n: 1, title: 'Overview of the Service',
    body: 'PayDirt is a news and prediction platform that enables users to evaluate information, form views on journalistic outcomes and assess the credibility of information, with performance tracked over time based on the accuracy and consistency of those assessments. The platform is designed both as a news and media environment and as a tool for users to apply logic, evaluate information, and think critically about world events, journalism, and politics, while measuring analytical skill, consistency, and accuracy over time rather than chance. PayDirt does not provide gambling services, wagering, or financial instruments.',
  },
  {
    n: 2, title: 'Eligibility',
    body: 'To use PayDirt, you must: be at least 18 years old, comply with all laws applicable in your jurisdiction, and not use the platform where such services are prohibited. Participation is void where prohibited by law. PayDirt reserves the right to restrict or terminate access at its discretion.',
  },
  {
    n: 3, title: 'Accounts',
    body: 'You agree to: provide accurate and complete information, maintain the security of your account, and be responsible for all activity under your account. Accounts may be suspended or terminated for abuse, manipulation, or violation of these Terms.',
  },
  {
    n: 4, title: 'Prediction System and Scoring',
    body: 'PayDirt evaluates users based on predictive performance over time. Scoring is based on a combination of six evaluation factors: Evidence traceability (25%) \u2014 the extent to which claims can be verified and traced to identifiable sources. Source independence (20%) \u2014 whether reporting relies on multiple independent sources or a single source. Claim confidence (15%) \u2014 whether the strength of language used matches the strength of the supporting evidence. Headline accuracy (20%) \u2014 whether headlines accurately reflect the content of the underlying article. Correction record (5%) \u2014 whether the outlet demonstrates a pattern of correcting errors over time. AI-assisted detection and analysis \u2014 systems used to evaluate content integrity, authorship signals, or potential manipulation. No single prediction determines performance outcomes. All scoring methodologies, factor weightings, detection systems, and evaluation criteria are determined and may be updated by PayDirt at its discretion.',
  },
  {
    n: 5, title: 'Rewards and Recognition',
    body: 'PayDirt may, from time to time, offer rewards, recognition, or incentives to users based on performance. Rewards are not guaranteed. Rewards are discretionary and may be modified, delayed, or withheld. Rewards are based on aggregated performance, not individual predictions. Users must meet all eligibility and verification requirements. Rewards have no inherent monetary value unless explicitly stated. PayDirt reserves the right to determine reward criteria, verify user activity, and disqualify users for manipulation or abuse.',
  },
  {
    n: 6, title: 'No Gambling or Wagering',
    body: 'PayDirt is a skill-based platform. No real-money wagering occurs. Users do not stake funds. Outcomes are not determined by chance alone. The platform is intended for informational, analytical, and entertainment purposes only.',
  },
  {
    n: 7, title: 'No Financial Advice',
    body: 'Content and predictions on PayDirt do not constitute financial advice, investment recommendations, or trading signals. Users should not rely on the platform for financial decisions.',
  },
  {
    n: 8, title: 'Prohibited Conduct',
    body: 'You agree not to: use bots, scripts, or automation, attempt to manipulate scoring systems, exploit platform vulnerabilities, or submit misleading or harmful content. Violation may result in suspension, termination, or disqualification from rewards.',
  },
  {
    n: 9, title: 'Intellectual Property',
    body: 'All platform content, design, and technology are owned by PayDirt or its licensors. You may not reproduce or exploit any part of the platform without permission.',
  },
  {
    n: 10, title: 'Termination',
    body: 'PayDirt may suspend or terminate access at any time, with or without notice. Users may also discontinue use at any time.',
  },
  {
    n: 11, title: 'Limitation of Liability',
    body: 'To the fullest extent permitted by law, PayDirt is not liable for inaccuracies in content or predictions, loss of data, scores, or rewards, or platform interruptions or errors. Use of the platform is at your own risk.',
  },
  {
    n: 12, title: 'Changes to Terms',
    body: 'PayDirt may update these Terms at any time. Continued use of the platform constitutes acceptance of updated Terms.',
  },
  {
    n: 13, title: 'Governing Law',
    body: 'These Terms are governed by the laws applicable to the operator of the platform.',
  },
  {
    n: 14, title: 'Third Party Content',
    body: 'PayDirt links to third party content including news articles and videos. All linked content remains the property of its respective owners. PayDirt is not responsible for the content, accuracy, or availability of third party sites. Links do not constitute endorsement of any third party content or source.',
  },
];

export default function TermsPage({ setPage }) {
  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '40px 20px 80px', fontFamily: "'DM Sans', sans-serif" }}>
      <button
        onClick={() => setPage('home')}
        style={{
          background: 'none', border: 'none', color: '#00e676',
          fontSize: 12, cursor: 'pointer', fontFamily: 'JetBrains Mono, monospace',
          marginBottom: 32, padding: 0,
        }}
      >
        &larr; Back to PayDirt
      </button>

      <h1 style={{ fontFamily: "'Dela Gothic One', cursive", fontSize: 22, color: '#fff', marginBottom: 8 }}>
        PAYDIRT TERMS AND CONDITIONS
      </h1>
      <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11, color: '#666', marginBottom: 28 }}>
        Last updated: March 19, 2026
      </p>

      <p style={{ color: '#9ca3af', fontSize: 14, lineHeight: 1.7, marginBottom: 36 }}>
        Welcome to PayDirt (paydirtnews.com). By accessing or using the platform, you agree to these Terms and Conditions and our{' '}
        <span onClick={() => setPage('privacy')} style={{ color: '#00e676', textDecoration: 'underline', cursor: 'pointer' }}>
          Privacy Policy
        </span>.
      </p>

      {SECTIONS.map(s => (
        <div key={s.n} style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 8 }}>
            <span style={{ color: '#00e676', fontFamily: 'JetBrains Mono, monospace', marginRight: 8 }}>{s.n}.</span>
            {s.title}
          </h2>
          <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.75 }}>{s.body}</p>
        </div>
      ))}
    </div>
  );
}
